module.exports = __webpack_public_path__ + "media/images/web/home/index/theatre-4c83f6a642a136aeb5b2f729c5d0ce1c.jpg";